<template>
    <div class="center w-full">
        <div class="flex w-full justify-content-center align-items-center">
            <div class="flex flex-column w-full py-4 xl:py-6 lg:py-5 md:py-4 xl:border-round-xl lg:border-round-xl">
                <span
                    class="flex text-900 font-medium mb-4 xl:mb-6 text-3xl xl:text-6xl lg:text-5xl md:text-4xl justify-content-center align-items-center text-center">
                    {{ header[lang].title }}
                </span>
                <div class="grid justify-content-start align-items-start w-full" style="margin-left:0">

                    <AboutCard 
                        :imageUrl="'/images/svg/about/clients.svg'" 
                        :descHead="about_clients[lang].title"
                        :descBody="about_clients[lang].content" 
                        :descButton="about_clients[lang].button"
                        :imageLink="false" 
                        type="clients" />

                    <AboutCard 
                        :imageUrl="'/images/svg/about/merchant.svg'" 
                        :descHead="about_merchant[lang].title"
                        :descBody="about_merchant[lang].content" 
                        :descButton="about_merchant[lang].button"
                        :descLink="about_merchant[lang].link" 
                        type="merchant"
                        :imageLink="true" />

                    <AboutCard 
                        :imageUrl="'/images/svg/about/partner.svg'" 
                        :descHead="about_partner[lang].title"
                        :descBody="about_partner[lang].content" 
                        :descButton="about_partner[lang].button"
                        :descLink="about_partner[lang].link" 
                        :imageLink="true" 
                        type="partner" />

                    <AboutCard 
                        :imageUrl="'/images/svg/about/invest.svg'" 
                        :descHead="about_invest[lang].title"
                        :descBody="about_invest[lang].content"
                        :descButton="about_invest[lang].button"
                        :descLink="about_invest[lang].link" 
                        type="invest"
                        :imageLink="true" />

                </div>

                <MainReviewsSlider />
                <MainStat />
                
            </div>
        </div>
    </div>
</template>

<script>
import AboutCard            from "@/components/widgets/AboutCard.vue"
import MainReviewsSlider    from '@/components/widgets/main/MainReviewsSlider.vue'
import MainStat             from '@/components/widgets/main/MainStat.vue'
import { mapActions }   from 'vuex'

export default {
    data() {
        return {
            header: {
                en: { title: "About" },
                ru: { title: "О сервисе" },
            },
            about_clients: {
                en: {
                    title: "For clients",
                    content:
                        "My team and I have developed a service that allows you to make simple and secure transfers between people in different countries.",
                    button: "Transfer",
                },
                ru: {
                    title: "Клиентам",
                    content:
                        "Мы с командой разработали сервис позволяющий выполнять простые и безопасные переводы между людьми в разных странах.",
                    button: "Сделать перевод",
                },
            },
            about_invest: {
                en: {
                    title: "Investors",
                    content:
                        "Become part of our team - help us become the most popular international translation service. Details below.",
                    button: "Details",
                    link: "Find out details",
                },
                ru: {
                    title: "Инвесторам",
                    content:
                        "Станьте частью нашей команды – помогите нам стать самым востребованным сервисом международных переводов. Подробности ниже.",
                    button: "Подробности",
                    link: "Узнать подробности",
                },
            },
            about_merchant: {
                en: {
                    title: "Merchants",
                    content:
                        "Welcome to our team. With your help, we can make transfers all over the world. We have good commissions and a high level of automation.",
                    button: "Become a merchant",
                    link: "How to become a merchant",
                },
                ru: {
                    title: "Мерчантам",
                    content:
                        "Добро пожаловать в нашу команду. С вашей помошью мы можем осуществлять переводы по всему миру. У нас хорошие комисии и высокий уровень автоматизации.",
                    button: "Стать мерчантом",
                    link: "Как стать мерчантом",
                },
            },
            about_partner: {
                en: {
                    title: "For partners",
                    content:
                        "Anyone can become a partner. Anyone can earn a nice bonus. You need to get your affiliate link and tell your friends.",
                    button: "Стать партнером",
                    link: "Become a partner",
                },
                ru: {
                    title: "Партнерам",
                    content:
                        "Любой может стать партнером. Любой может заработать приятный бонус. Нужно получить свою партнерскую ссылку и рассказать друзьям.",
                    button: "Стать партнером",
                    link: "Стать партнером",
                },
            },
            about: {
                en: { content: 'PayWave is an innovative and modern service for fast and secure money transfers. We are designed with our customers’ needs in mind, aiming to make the process of transfers easier and provide a high level of user satisfaction. Our company is founded on the values of transparency, security and reliability.' },
                ru: { content: 'PayWave - это инновационный и современный сервис для быстрых и безопасных денежных переводов. Мы спроектированы с учетом потребностей наших клиентов, стремясь облегчить процесс переводов и обеспечить высокий уровень удовлетворенности пользователей. Наша компания основана на ценностях прозрачности, безопасности и надежности.' }
            },
            do_title: {
                en: { content: "What we do" },
                ru: { content: "Что делаем" },
            },
            do_text: {
                en: { content: 'PayWave provides fast money transfers both within the country and abroad. We understand that fast and convenient access to money is of great importance in the modern world, so our goal is to provide a flawless funds exchange experience for all our customers.' },
                ru: { content: 'PayWave предоставляет быстрые денежные переводы как внутри страны, так и за рубеж. Мы понимаем, что быстрый и удобный доступ к деньгам имеет огромное значение в современном мире, поэтому наша цель - обеспечить безупречный опыт обмена средств для всех наших клиентов.' }
            },
            benefits_title: {
                en: { content: "Benefits" },
                ru: { content: "Преимущества" },
            },
            benefits: {
                en: [
                    {
                        title: 'Speed',
                        content: 'Our system is based on cutting-edge technologies, which allows us to conduct money transfers quickly. You won’t have to wait in long queues or delays - the money will reach the recipient almost instantly.'
                    },
                    {
                        title: 'Security',
                        content: 'We give the highest value to the security of your funds and personal information. Our system is protected by modern encryption technologies, which guarantees the confidentiality and protection of all operations.'
                    },
                    {
                        title: 'Convenience',
                        content: 'PayWave is designed with ease of use in mind. Our intuitive interface allows you to quickly get used to our service even for beginners, and make transfers in just a few clicks.'
                    },
                    {
                        title: 'Globality',
                        content: 'Our service is available for international transfers, which makes us the optimal choice for those who need to send money abroad. We work with different currencies and countries to provide our customers with wide opportunities.'
                    }
                ],
                ru: [
                    {
                        title: 'Быстрота',
                        content: 'Наша система основана на передовых технологиях, что позволяет нам проводить денежные переводы быстро. Вам не придется ждать долгих очередей или задержек - деньги окажутся у получателя почти мгновенно.'
                    },
                    {
                        title: 'Безопасность',
                        content: 'Мы придаем самое высокое значение безопасности ваших денежных средств и личной информации. Наша система защищена современными технологиями шифрования, что гарантирует конфиденциальность и защиту всех операций.'
                    },
                    {
                        title: 'Удобство',
                        content: 'PayWave разработан с учетом простоты использования. Наш интуитивно понятный интерфейс позволяет быстро освоиться с нашим сервисом даже новичкам, и выполнять переводы всего в несколько кликов.'
                    },
                    {
                        title: 'Глобальность',
                        content: 'Наш сервис доступен для международных переводов, что делает нас оптимальным выбором для тех, кто нуждается в пересылке денег за границу. Мы работаем с различными валютами и странами, чтобы обеспечить широкие возможности нашим клиентам.'
                    }
                ],
            },
            in_numbers: {
                head: {
                    en: { content: "PayWave in numbers" },
                    ru: { content: "PayWave в цифрах" },
                },
                successful: {
                    en: { content: "Successful transfers" },
                    ru: { content: "Успешных переводов" },
                },
                total: {
                    en: { content: "Total transferred amount" },
                    ru: { content: "Общая сумма переводов" },
                },
                active_users: {
                    en: { content: "Number of active users" },
                    ru: { content: "Число активных пользователей" },
                }
            },
            faq_and_reviews: {
                en: { content: "FAQ & Reviews" },
                ru: { content: "Инструкция и Отзывы" },
            },
            buttons: {
                en: {
                    faq: "Explore user's FAQ",
                    reviews: "See our users reviews",
                },
                ru: {
                    faq: "Изучить FAQ пользователя",
                    reviews: "Посмотреть отзывы наших пользователей",
                }
            },

        }
    },
    methods: {
        ...mapActions(['SetHeaderTitle', 'SetHeaderBtnLeftFirst', 'SetHeaderBtnLeftSecond', 'SetHeaderBtnRightFirst', 'SetHeaderBtnRightSecond']),
        go_faq() {
            this.$router.push({
                path: '/faq/'
            })
        },
        go_reviews() {
            this.$router.push({
                path: '/reviews/'
            })
        },
        go_transfer() {
            this.$router.push({
                path: "/personal/transfer/create/",
            });
        },
        go_to_partner() {
            this.$router.push({
                path: "/personal/partner/",
            });
        },
    },
    computed: {
        lang() { return (this.$i18n.locale) ? this.$i18n.locale : 'ru' }
    },
    components: {
        AboutCard,
        MainReviewsSlider,
        MainStat,
    },
    mounted() {
        try{ window.scrollTo({ top: 0, behavior: 'smooth' }) } catch {}

        try {
            this.SetHeaderTitle(this.header[this.lang].title)
            this.SetHeaderBtnLeftFirst({
                type: 'backward',
                icon: 'pi pi-arrow-left',
                class: 'text-xs',
                rounded: true,
                severity: 'secondary',
                visible: true,
            })
            this.SetHeaderBtnLeftSecond({})
            this.SetHeaderBtnRightFirst({
                class: 'text-xs opacity-0',
                visible: true,
            })
            this.SetHeaderBtnRightSecond({})
        } catch (error) {
            console.error('Error setting header:', error)
        }
    }
}
</script>